// @flow

export { default } from './WatchWindowSize';
